import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const StyledWrapper = styled.div`
  background-color: ${primitive.th.$coffeeBrown};
  padding: 0.5rem 1.5rem;
  color: ${primitive.$white};
  text-align: center;
`;
